export default __webpack_public_path__ + "static/media/icons-link.67616b87.svg";